/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const alertContentLegalbirdStyle = {
  description: (theme: Theme) => ({
    paddingTop: "1rem",
    color: theme.palette.text.primary,
    //overwrite dangerouslySetInnerHTML ul default margin
    "& ul": {
      margin: "0rem",
    },
  }),
  actions: (theme: Theme) => ({
    alignItems: "flex-end",
    height: "100%",
    [theme.breakpoints.up("lg")]: {
      paddingTop: "0",
      justifyContent: "flex-end",
    },
  }),
};
